module.exports = __webpack_public_path__ + "img/op_img-card-1.884a261.jpg";